class BenefitsTimeline extends HTMLElement {
    constructor() {
        super();
        this.section = this.querySelector('.timeline-section');
        if (!this.section) return;

        // Use IntersectionObserver to trigger animation when section is in view
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.section.classList.add('is-visible');
                        // Animate only once per page load
                        this.observer.disconnect();
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.3 // Trigger when 30% of the section is visible
            }
        );

        this.observer.observe(this.section);
    }
}

if (!customElements.get('benefits-timeline')) {
    customElements.define('benefits-timeline', BenefitsTimeline);
}
